<div ref:stLouisMap id="st-louis-map">
	<!-- {{#if sceneIndex > 2}} -->
	<div class='key-container'>
		<ScrollerKey sceneIndex={{sceneIndex}} />
	</div>
	<!-- {{/if}} -->
</div>


<style>
#st-louis-map {
	height: 600px;
	width: 100%;
	position: relative;
}

.leaflet-interactive {
	-webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
	-moz-animation: fadein 2s; /* Firefox < 16 */
	-ms-animation: fadein 2s; /* Internet Explorer */
	-o-animation: fadein 2s; /* Opera < 12.1 */
	animation: fadein 2s;
	/*stroke: transparent;*/
}

.leaflet-control-zoom {
	display: none;
}

.key-container {
	z-index: 10000;
	position: absolute;
	bottom: 0;
	left: 0;
	height: 168px;
}
</style>

<script>
import { Promise, get as giaGet } from 'gia-toolkit';
import ScrollerKey from './ScrollerKey.html';
const STEPS = 15;

export default {
	data () {
		return {
			geojson_layer: null,
			selectedFieldId: null,
			stLouisCensusData: null,
			stlBoundary: null,
			width: 800,
			numScenesExperienced: []
		};
	},

	onrender () {
		this.container = this.refs.stLouisMap;
		const self = this;

		window.addEventListener( 'resize', () => {
			self.resize();
		});

		this.resize();

		const promise = Promise.all([

			giaGet( '<@baseUrl@>/<@version@>/files/st-louis-tract-data.json' ).then( x => {
				this.set({stLouisCensusData: JSON.parse( x ) });
			}),

			giaGet( '<@baseUrl@>/<@version@>/files/st-louis-census-tracts.geo.json' ).then( x => {
				this.set({tract_data: x});
			})
		]).then( () => {
			this.L = window.L;
			// 38.6435607,-90.1598646 <--shifted over
			// 38.65334327823747, -90.24375915527345 <-- centered
			this.stlMap = this.L.map( 'st-louis-map' ).setView([ 38.6435607,-90.1598646 ], 11 );
			window.stlMap = this.stlMap;
			this.L.tileLayer( 'https://api.mapbox.com/styles/v1/gia/citxdomqb005d2io4f12je4gt/tiles/256/{z}/{x}/{y}?access_token={accessToken}', {
				attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
				maxZoom: 11,
				minZoom: 11,
				id: 'mapbox.satellite',
				accessToken: 'pk.eyJ1IjoiZ2lhIiwiYSI6Imo0MGlwN0EifQ.lJnbqEqj60ejSGx9s4ht2w'
			}).addTo( this.stlMap );
		}).then( () => {
			// console.log(this.get('tract_data'), 'TRACT DATA')
			const tract_data = this.get( 'tract_data' );
			const geojson_layer = this.L.geoJson( JSON.parse( tract_data ), {style: this.style.bind( this )});
			this.set({geojson_layer});
		})
		.then( () => {
			giaGet( '<@baseUrl@>/<@version@>/files/st-louis-murders.json' ).then( x => {
				const stlIncidents = JSON.parse( x );
				const stlMurders = [];
				stlIncidents.forEach( incident => {
					const circle = this.L.circle([ incident.randomLat, incident.randomLon ], {
						color: '#333',
						fillColor: '#333',
						fillOpacity: 0.2,
						// strokeOpacity: 0.2,
						radius: 1,
						incidentId: incident['Incident ID'],
						randomLat: incident.randomLat,
						randomLon: incident.randomLon,
						realLat: incident.realLat,
						realLon: incident.realLon,
						realToRandomLat: this.generateMidpoints( incident.realLat, incident.randomLat ),
						realToRandomLon: this.generateMidpoints( incident.realLon, incident.randomLon ),
						randomToRealLat: this.generateMidpoints( incident.randomLat, incident.realLat ),
						randomToRealLon: this.generateMidpoints( incident.randomLon, incident.realLon )
					});
					stlMurders.push( circle );
				});
				this.stlMurderDots = this.L.layerGroup( stlMurders );
			})
			.then( () => {

				this.observe('width', width => {

					if ( width > 980 ) {
						this.stlMap.panTo([38.6435607,-90.1598646]);
					} else {
						this.stlMap.panTo([38.6185932,-90.241286]);
						// 38.6131232,-90.241152 alternate lower
						//38.65334327823747, -90.24375915527345 original
					}

				});

				this.observe( 'sceneIndex', sceneIndex => {
					const geojson_layer = this.get( 'geojson_layer' );
					const stlBoundary = this.get( 'stlBoundary' );
					const numScenesExperienced = this.get( 'numScenesExperienced');
					numScenesExperienced.push( sceneIndex );
					this.set({ numScenesExperienced });
					if ( sceneIndex === 0 ) {

						if ( this.stlMap.hasLayer( geojson_layer ) ) {
							this.stlMap.removeLayer( geojson_layer );
						}
						if ( this.stlMap.hasLayer( this.stlMurderDots ) ) {
							this.stlMap.removeLayer( this.stlMurderDots );
						}
						this.drawStlBoundary();

					} else if ( sceneIndex === 1 ) {

						if ( this.stlMap.hasLayer( geojson_layer ) ) {
							this.stlMap.removeLayer( geojson_layer );
						}
						if ( !this.stlMap.hasLayer( stlBoundary ) ) {
							this.drawStlBoundary();
						}
						// this.makeTractChoropleth();
						this.drawRandomDots();

					} else if ( sceneIndex === 2 ) {

						if ( this.stlMap.hasLayer( geojson_layer ) ) {
							this.stlMap.removeLayer( geojson_layer );
						}
						if ( !this.stlMap.hasLayer( stlBoundary ) ) {
							this.drawStlBoundary();
						}
						this.drawRealDots();

					} else if ( sceneIndex === 3 ) {

						this.set({selectedFieldId: 'percent_poor'});
						if ( this.stlMap.hasLayer( stlBoundary ) ) {
							this.stlMap.removeLayer( stlBoundary );
						}
						if (this.stlMap.hasLayer(this.stlMurderDots)) {
						this.stlMap.removeLayer(this.stlMurderDots);
					}
						this.makeTractChoropleth();
						if (numScenesExperienced.length < 3) {
							this.drawRandomDots();
						}
						this.drawRealDots()
						this.drawStlBoundary();


					} else if ( sceneIndex === 4 ) {

						this.set({selectedFieldId: 'percent_education'});
						if ( this.stlMap.hasLayer( stlBoundary ) ) {
							this.stlMap.removeLayer( stlBoundary );
						}
						if (this.stlMap.hasLayer(this.stlMurderDots)) {
						this.stlMap.removeLayer(this.stlMurderDots);
					}
						this.makeTractChoropleth();
						if (numScenesExperienced.length < 3) {
							this.drawRandomDots();
						}
							this.drawRealDots()
						this.drawStlBoundary();

					} else if ( sceneIndex === 5 ) {

						this.set({selectedFieldId: 'percent_black'});
						if ( this.stlMap.hasLayer( stlBoundary ) ) {
							this.stlMap.removeLayer( stlBoundary );
						}
						if (this.stlMap.hasLayer(this.stlMurderDots)) {
						this.stlMap.removeLayer(this.stlMurderDots);
					}
						this.makeTractChoropleth();
						if (numScenesExperienced.length < 3) {
							this.drawRandomDots();
						}
							this.drawRealDots()
						this.drawStlBoundary();
					}
				});
			});
		});
	},
	methods: {
		drawRealDots: function () {
			if ( !this.stlMap.hasLayer( this.stlMurderDots ) ) {
				this.stlMap.addLayer( this.stlMurderDots );
			} else {
				let counter = 0;
				const animateDots = setInterval( () => {
					this.stlMurderDots.eachLayer( x => {
						// console.log(x)
						x.setLatLng([ x.options.randomToRealLat[counter], x.options.randomToRealLon[counter] ]);
					});
					if ( counter === STEPS ) {
						clearInterval( animateDots );
					}
					counter++;
				},
				10 );
			}
		},

		drawRandomDots: function () {
			if ( !this.stlMap.hasLayer( this.stlMurderDots ) ) {
				this.stlMurderDots.eachLayer( x => {
					x.setLatLng([ x.options.randomLat, x.options.randomLon ]);
				});
				this.stlMap.addLayer( this.stlMurderDots );
			} else {
				let counter = 0;
				const animateDots = setInterval( () => {
					this.stlMurderDots.eachLayer( x => {
						x.setLatLng([ x.options.realToRandomLat[counter], x.options.realToRandomLon[counter] ]);
					});
					if ( counter === STEPS ) {
						clearInterval( animateDots );
					}
					counter++;
				},
				10 );
			}
		},

		generateMidpoints:  function ( first, last ) {
			const increment = Math.abs( +first - +last ) / STEPS;
			const stops = [];
			for ( let i = 0; i < STEPS; i += 1 ) {
				const nextStep = +first < +last ? ( +first + ( increment * i ) ) : ( +first - ( increment * i ) );
				stops.push( nextStep );
			}
			stops.push( +last );
			return stops;
		},

		drawStlBoundary: function () {

			giaGet( '<@baseUrl@>/<@version@>/files/st-louis-outline.geo.json' ).then( x => {
				const stlBoundary = this.L.geoJson( JSON.parse( x ), { style: {
					fillColor: 'white',
					weight: 1.5,
					opacity: 1,
					color: '#767676',
					fillOpacity: 0
				}}).addTo( this.stlMap );
				this.set({stlBoundary});
			});
		},

		makeTractChoropleth: function () {
			const geojson_layer = this.get( 'geojson_layer' );
			if ( geojson_layer ) {
				geojson_layer.eachLayer( layer => {
					geojson_layer.resetStyle( layer );
				});
			}
			if ( !this.stlMap.hasLayer( geojson_layer ) ) {
				geojson_layer.addTo( this.stlMap );
			}
		},

		getColor: function ( tractId ) {
			const selectedFieldId = this.get( 'selectedFieldId' );
			const stLouisCensusData = this.get( 'stLouisCensusData' )
			const d = stLouisCensusData[tractId][selectedFieldId];

			if (selectedFieldId === 'percent_poor') {

				return d > 90 ? '#f6f6f6' :
				d > 80 ? '#f6f6f6' :
				d > 70 ? '#507892' :
				d > 60 ? '#66879f' :
				d > 50 ? '#7b98ac' :
				d > 40 ? '#91a8ba' :
				d > 30 ? '#a7b9c8' :
				d > 20 ? '#bdcad5' :
				d > 10 ? '#d2dbe3' :
				d > 0 ? '#e9eef1' :
				'#f6f6f6';

			} else if (selectedFieldId === 'percent_education') {

				return d > 90 ? '#f6f6f6' :
				d > 80 ? '#f6f6f6' :
				d > 70 ? '#951c55' :
				d > 60 ? '#a43f68' :
				d > 50 ? '#b45c7c' :
				d > 40 ? '#c27791' :
				d > 30 ? '#cf91a6' :
				d > 20 ? '#dcacbb' :
				d > 10 ? '#e8c7d1' :
				d > 0 ? '#f4e3e8' :
				'#f6f6f6';


			} else if (selectedFieldId === 'percent_black') {
				return d > 90 ? '#c05303' :
				d > 80 ? '#ca6425' :
				d > 70 ? '#d4753d' :
				d > 60 ? '#dc8655' :
				d > 50 ? '#e4976c' :
				d > 40 ? '#eba883' :
				d > 30 ? '#f1b99c' :
				d > 20 ? '#f6cab4' :
				d > 10 ? '#fadccc' :
				d > 0 ? '#fdeee6' :
				'#f6f6f6';
			}
		},

		style: function (feature) {
			const tractId = feature.properties.TRACTID;

			return {
				fillColor: this.getColor( tractId ),
				weight: 2,
				opacity: 1,
				color: 'rgba(255, 255, 255,.2)',
				dashArray: '3',
				fillOpacity: 0.9
			};
		},

		resize () {
			this.set({
				width: this.container.getBoundingClientRect().width
				// height: this.container.getBoundingClientRect().height
			});
		}

	},
	components: {
		ScrollerKey
	}

};
</script>
